export const enum LANG {
  EN = "en",
  FIN = "fin",
}

export const LANGUAGES = [LANG.EN, LANG.FIN] as const;
